import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getOrderOriginsActionAsync } from '../redux/actions/orderOriginActions'

export const useOrderOrigins = () => {
  const { orderOriginsState } = useSelector(
    (state: RootState) => state.orderOrigin
  )
  const dispatch = useDispatch()

  const getOrderOrigins = () => {
    dispatch(getOrderOriginsActionAsync())
  }

  return { orderOriginsState, getOrderOrigins }
}
